import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { filter } from 'rxjs';
import { AlertService } from '../../shared/alert/service/alert.service';

@Injectable({ providedIn: 'root' })
export class PwaUpdateService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly alert = inject(AlertService);

  init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(filter(event => event.type === 'VERSION_READY'))
      .subscribe(() => {
        this.alert.show(
          'A new version is available. Update now to get the latest features.',
          'info',
          0,
          {
            actionText: 'Update',
            cancelText: 'Later',
            onAction: () => {
              this.swUpdate.activateUpdate().then(() => document.location.reload());
            }
          }
        );
      });

    this.swUpdate.unrecoverable.subscribe(() => {
      this.alert.show(
        'The app needs to reload due to an update error.',
        'warning',
        0,
        {
          actionText: 'Reload',
          onAction: () => document.location.reload()
        }
      );
    });
  }
}
